const ON_DEMAND_RANDOM_TADK_ID_FORMAT_SEPARATOR = '-';
const ON_DEMAND_RANDOM_TASK_ID_FORMAT = '8-4-4-4-12';
export const ON_DEMAND_TASK_ID_QUICK_SCAN = 'da29f7c8-23b1-4974-8d11-209959ac694b';
export const ON_DEMAND_TASK_ID_FULL_SCAN = 'dcf483c4-26d0-4e6f-ba28-6a53a00adae1';

// Returns a random number between min and max
function rand(min, max) {
  return Math.random() * (max - min) + min;
}

function dechex(number) {
  if (number < 0) {
    number = 0xffffffff + number + 1;
  }
  return parseInt(number, 10).toString(16);
}

export function generateRandomTaskId() {
  // array with parts of result code
  const randomChunks: string[] = [];

  // make an array with length of substrings of random generated code
  const chunks = ON_DEMAND_RANDOM_TASK_ID_FORMAT.split(ON_DEMAND_RANDOM_TADK_ID_FORMAT_SEPARATOR);
  for (let i = 0; i < chunks.length; i++) {
    let randomChunk = '';

    // generate each substrig of random code
    for (let j = 0; j < parseInt(chunks[i], 10); j++) {
      randomChunk += dechex(rand(0, 15));
    }

    randomChunks.push(randomChunk);
  }

  // build generated random code (Join the elements of the array into a string)
  return randomChunks.join(ON_DEMAND_RANDOM_TADK_ID_FORMAT_SEPARATOR);
}
